import { Controller } from "@hotwired/stimulus"
import { sendHubspotForm } from "services/hubspot_helper"

// Signup thank-you pages that submit the hidden HubSpot form after it is ready.
export default class extends Controller {
  static values = {
    lastName: String,
    firstName: String,
    email: String,
    company: String,
    jobTitle: String,
    accountId: String,
    redirectUrl: String,
    redirectDelay: Number,
  }

  connect() {
    if (window.dataLayer) window.dataLayer.push({ event: "developer_signup" })
    window.addEventListener("message", this.handleHubspotMessage)

    if (this.hasRedirectUrlValue && this.hasRedirectDelayValue) {
      this.redirectTimer = window.setTimeout(() => {
        window.location.href = this.redirectUrlValue
      }, this.redirectDelayValue)
    }
  }

  disconnect() {
    window.removeEventListener("message", this.handleHubspotMessage)
    if (this.redirectTimer) window.clearTimeout(this.redirectTimer)
  }

  handleHubspotMessage = (event) => {
    if (!event.data) return
    if (event.data.type !== "hsFormCallback" || event.data.eventName !== "onFormReady") return

    sendHubspotForm(
      this.lastNameValue,
      this.firstNameValue,
      this.emailValue,
      this.companyValue,
      this.jobTitleValue,
      this.accountIdValue,
    )
  }
}
